module.exports = __webpack_public_path__ + "img/4.5d50751a.png";